import React from 'react';
import { MdOutlineRateReview } from "react-icons/md";

const HorseSeller = React.memo(({ seller }) => {
  if (!seller) return null;

  const {
    firstName,
    lastName,
    email,
    profileDescription,
    isVerifiedSeller,
    completedTransactions = [],
    rating = 0,
    reviews = [],
  } = seller;

  console.log('👀 Seller reviews:', reviews); // Moved this line to use destructured version

  const soldCount = seller.horses?.sold?.length || 0;
  const boughtCount = seller.horses?.bought?.length || 0;

  return (
    <div className="mt-5 p-3 font-montserrat shadow text-text">
      <h2 className="text-xl font-bold mb-2">Seller Information</h2>

      <div className="space-y-1 text-sm text-text">
        <p className="py-2"><strong>Name:</strong> {firstName} {lastName}</p>
        <p className="py-2"><strong>Email:</strong> {email}</p>
        <p className="py-2">
          <strong>Verified:</strong>{' '}
          {isVerifiedSeller ? (
            <span className="text-green-600 font-semibold">✔ Yes</span>
          ) : (
            <span className="text-red-500 font-semibold">✖ No</span>
          )}
        </p>
        <p className="py-2"><strong>Horses Sold:</strong> {soldCount}</p>
        <p className="py-2"><strong>Horses Bought:</strong> {boughtCount}</p>
        <p className="py-2"><strong>Rating:</strong> {rating} / 5</p>
        <p className="py-2">
          <strong>About the Seller:</strong>{' '}
          {profileDescription || 'No description provided.'}
        </p>
      </div>

      {reviews.length > 0 && (
        <div className="mt-4 shadow p-2">
          <p className="mb-2 text-text"><MdOutlineRateReview className="inline pr-2 h-8 w-8" /><strong>Reviews</strong></p>
          <ul className="text-sm space-y-1 text-gray-600">
            {reviews.map((r, i) => (
              <li key={i}>
                <p className="font-semibold text-text py-1">Rating: {r.rating} / 5</p>
                <p className="italic text-text py-1">"{r.comment}"</p>
                <p className="text-xs text-gray-500 py-1">Reviewer: {r.reviewer || 'Anonymous'} • {new Date(r.createdAt).toLocaleDateString()}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
});

export default HorseSeller;